import type { SupportedLocale } from '@erp/shared';
export const documentEntryTranslations = {
  de: {
    title: 'Kundendaten-Vorschau',
    loading: 'Kundenvorgaben werden geladen …',
    loadError: 'Kundenvorgaben konnten nicht geladen werden',
    preview: 'Vorschau der Kundendaten. Der Beleg wird erst beim Speichern angelegt.',
    unsaved: 'Ungespeicherte Änderungen verwerfen und den Beleg verlassen?',
  },
  en: {
    title: 'Customer data preview',
    loading: 'Loading customer defaults …',
    loadError: 'Could not load customer defaults',
    preview: 'Customer data preview. The document is created only when you save.',
    unsaved: 'Discard unsaved changes and leave the document?',
  },
  fr: {
    title: 'Aperçu des données client',
    loading: 'Chargement des valeurs du client …',
    loadError: 'Impossible de charger les valeurs du client',
    preview: 'Aperçu des données client. Le document est créé uniquement lors de l’enregistrement.',
    unsaved: 'Abandonner les modifications non enregistrées et quitter le document ?',
  },
  es: {
    title: 'Vista previa de datos del cliente',
    loading: 'Cargando los valores del cliente …',
    loadError: 'No se pudieron cargar los valores del cliente',
    preview: 'Vista previa de los datos del cliente. El documento se crea al guardar.',
    unsaved: '¿Descartar los cambios sin guardar y salir del documento?',
  },
  tr: {
    title: 'Müşteri verileri önizlemesi',
    loading: 'Müşteri varsayılanları yükleniyor …',
    loadError: 'Müşteri varsayılanları yüklenemedi',
    preview: 'Müşteri verilerinin önizlemesi. Belge yalnızca kaydettiğinizde oluşturulur.',
    unsaved: 'Kaydedilmemiş değişiklikler silinip belgeden çıkılsın mı?',
  },
} satisfies Record<SupportedLocale, Record<string, string>>;
